module.exports = __webpack_public_path__ + "img/rechazado.51e9d41d.png";